import styled, { css, keyframes } from 'styled-components';
import { skeleton } from 'src/components/skeleton';
import * as Shared from '../MediaPreviewShared/styles';
import { PREVIEW_ANIMATION } from './constants';

const rowExpand = keyframes`
  from {
    grid-template-rows: 0fr;
  }

  to {
    grid-template-rows: 1fr;
  }
`;

const mediaReveal = keyframes`
  from {
    opacity: 0;
    transform: scale(0.92);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const ExpandRow = styled.div<{ $delayMs: number }>(
  ({ $delayMs }) => css`
    display: grid;
    grid-template-rows: 0fr;
    animation: ${rowExpand} ${PREVIEW_ANIMATION.rowExpandMs}ms ease-out forwards;
    animation-delay: ${$delayMs}ms;
  `,
);

export const ExpandRowInner = styled.div(
  () => css`
    overflow: hidden;
    min-height: 0;
  `,
);

export const TitleSkeleton = styled.div(
  ({ theme }) => css`
    width: ${theme.sz.s16};
    height: ${theme.sz.s5};
    border-radius: ${theme.bo.small};
    ${skeleton};
  `,
);

export const WordListSkeleton = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.sz.s2};
    width: 100%;
  `,
);

export const WordSkeleton = styled.div(
  ({ theme }) => css`
    width: min(100%, ${theme.sz.s40});
    height: ${theme.sz.s10};
    border-radius: ${theme.bo.round};
    ${skeleton};
  `,
);

export const MediaSkeletonWrap = styled.div(
  ({ theme }) => css`
    height: 100%;
    width: ${theme.sz.s74};
    max-width: 100%;
    opacity: 0;
    animation: ${mediaReveal} ${PREVIEW_ANIMATION.rowExpandMs}ms ease-out forwards;
    animation-delay: ${PREVIEW_ANIMATION.mediaDelayMs}ms;

    @media (max-width: ${theme.sz.lg}) {
      width: min(100%, ${theme.sz.s48});
      height: auto;
      margin-inline: auto;
    }
  `,
);

export const MediaSkeleton = styled(Shared.Container)(
  ({ theme }) => css`
    ${skeleton};
    height: 100%;
    width: 100%;
    aspect-ratio: auto;

    @media (max-width: ${theme.sz.lg}) {
      height: auto;
      max-height: ${theme.sz.s64};
      aspect-ratio: 3 / 4;
    }
  `,
);
